export default {"src":"/_next/static/media/water_40.1d3ada82.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};